import React from 'react';

const FcfaIcon = ({ className = "h-6 w-6", ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      {/* Circle border */}
      <circle cx="12" cy="12" r="9" strokeLinecap="round" strokeLinejoin="round" />
      
      {/* F letter */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 8h6M8 8v8M8 12h4"
      />
      
      {/* Stylized currency symbol */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10v4m1-4v4m-1-2h1"
      />
    </svg>
  );
};

export default FcfaIcon;
